import { VITALL_CONSENT } from '@constants/consents';

import { useGetConsents } from '@hooks/api/consent';
import { useGetUser } from '@hooks/api/user';
import { useCuration } from '@hooks/useCuration';

import { useSession } from './useSession';

export function useCheckConsent() {
  const {
    state: { patientView },
  } = useCuration();
  const {
    state: { activeProfile },
  } = useSession();
  const [patient_id] = [activeProfile?.patient_id];

  const { data: userData, loading: userLoading } = useGetUser({
    id: activeProfile?.user_id ?? '',
  });
  const {
    data: consentData,
    loading: consentLoading,
    consentUnavailable,
  } = useGetConsents();
  const loading = userLoading || consentLoading;

  // Subject to change: Vitall consent to be moved to vitall_patient table
  const vitallConsent = consentData.find((d) => d.hasCategory(VITALL_CONSENT));
  const termsAndConditionsConsent = userData?.getUserRecord.toc_completed;
  const privateNoticeConsent = userData?.getUserRecord.pn_completed;
  // Patient: Need to consent to toc_pn and record collection
  // Non-patient: Need to consent to toc_pn only
  // A caregiver viewing another user's profile can't read that user's consents,
  // so consent gating doesn't apply to them; treat it as satisfied.
  const hasConsented =
    consentUnavailable ||
    (Boolean(termsAndConditionsConsent && privateNoticeConsent) &&
      (patient_id ? vitallConsent?.isActive() : true));

  return {
    data: {
      hasConsented,
      tocPnConsented: Boolean(
        termsAndConditionsConsent && privateNoticeConsent
      ),
      // T or null: Patient has consented or is not a patient (NA)
      // F: Patient has not consented
      vitallConsented: patient_id ? (vitallConsent?.isActive() ?? false) : null,
      isUnconsentingPatient: patientView && !hasConsented && !loading,
    },
    loading,
  };
}
